"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeInput = exports.decodeAttributeStringBeforeJSONParse = exports.stringyAndEscapeCharsForHTMLAttribute = exports.escapeHTMLChars = exports.toAttribute = exports.safeAttachShadow = exports.registerWebComponent = void 0;
const registerWebComponent = (componentName, elementClass) => {
    if (!customElements.get(componentName))
        customElements.define(componentName, elementClass);
};
exports.registerWebComponent = registerWebComponent;
/**
 * Safely attaches shadow DOM with fallback for monkey-patched environments
 * Handles Clarity.js and analytics library interference
 *
 * @param element - The custom element to attach shadow DOM to
 * @param mode - Shadow DOM mode (default: "open")
 * @returns ShadowRoot or the element itself as fallback
 */
function safeAttachShadow(element, mode = "open" // Default to open mode
) {
    //Check for existing shadow root first
    if (element.shadowRoot)
        return element.shadowRoot;
    const attachShadowFn = Element.prototype
        .attachShadow;
    // Following instruction #12 - Detect known problematic monkey patches
    const isMonkeyPatched = typeof attachShadowFn._swPatched !== "undefined" ||
        attachShadowFn.toString().includes("clarity") ||
        attachShadowFn.toString().includes("MutationObserver") ||
        attachShadowFn.toString().includes("marker") ||
        attachShadowFn.toString().includes("crazyegg");
    try {
        // Check if already attached (some libraries pre-attach)
        if (element.shadowRoot)
            return element.shadowRoot;
        // NOTE: Shadow DOM encapsulation prevents external CSS from affecting web components.
        return element.attachShadow({ mode: mode });
    }
    catch (error) {
        // Log once per session, not per component
        if (!window._swShadowDOMWarned) {
            const errorMessage = error instanceof Error ? error.message : String(error);
            const componentName = element.tagName.toLowerCase();
            console.warn(`[SugarWOD] Shadow DOM blocked by third-party script for <${componentName}>. ` +
                `Using light DOM fallback. This is normal and does not affect functionality.`, {
                error: errorMessage,
                monkeyPatched: isMonkeyPatched,
                component: componentName,
                //  Include script sources if detectable
                likelySource: errorMessage.includes("MutationObserver")
                    ? "Analytics script (Marker.io, CrazyEgg, or Clarity)"
                    : "Unknown third-party script",
            });
            window._swShadowDOMWarned = true;
        }
        // Fallback: Use light DOM
        // Return element cast as ShadowRoot for querySelector compatibility
        // This allows web components to continue functioning without shadow encapsulation
        return element;
    }
}
exports.safeAttachShadow = safeAttachShadow;
// NOTE: We "should" probably use kebab-case for attribute names ie "data-value" not "dataValue"
const toAttribute = (attribute, value) => {
    if (value === undefined || value === null || value === false)
        return "";
    if (value === true)
        return attribute;
    return `${attribute}="${String(value)}"`;
};
exports.toAttribute = toAttribute;
const escapeHTMLChars = (s) => {
    return s
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;");
};
exports.escapeHTMLChars = escapeHTMLChars;
/**
 * Escapes a JSON string for safe use in HTML attributes
 */
const stringyAndEscapeCharsForHTMLAttribute = (obj) => {
    return JSON.stringify(obj)
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
};
exports.stringyAndEscapeCharsForHTMLAttribute = stringyAndEscapeCharsForHTMLAttribute;
/**
 * Decodes HTML entities from an attribute value before JSON parsing
 */
const decodeAttributeStringBeforeJSONParse = (attrValue) => {
    return attrValue
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&apos;/g, "'")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&amp;/g, "&");
};
exports.decodeAttributeStringBeforeJSONParse = decodeAttributeStringBeforeJSONParse;
// Sanitize input to prevent XSS attacks
const sanitizeInput = (input) => {
    // Remove any HTML tags and encode special characters
    const div = document.createElement("div");
    div.textContent = input;
    return div.innerHTML;
};
exports.sanitizeInput = sanitizeInput;
//# sourceMappingURL=web-components.js.map